import React, { ChangeEvent, ReactNode } from 'react';

import { Box, Switch, Typography, TypographyProps } from '@mui/material';
import { InfoTooltip } from 'components/InfoTooltip';

interface SwitchControlProps {
  htmlId: string;
  checked: boolean;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  label: {
    text: ReactNode;
    variant: TypographyProps['variant'];
  };
  tooltip?: {
    placement: 'top' | 'bottom' | 'left' | 'right';
    text: ReactNode;
  };
}

export const SwitchControl = ({ htmlId, checked, onChange, label, tooltip }: SwitchControlProps) => (
  <Box display={{ xs: 'flex', md: 'inline-block' }}>
    <Switch sx={{ transform: 'translateY(-3px)' }} id={htmlId} checked={checked} onChange={onChange} />
    <Typography component="label" htmlFor={htmlId} display="inline" variant={label.variant} sx={{ mr: 2 }}>
      {label.text}
    </Typography>
    {tooltip ? (
      <Box sx={{ display: 'inline-block', transform: { xs: 'none', md: 'translateY(-4px)' } }}>
        <InfoTooltip placement={tooltip.placement} text={tooltip.text} />
      </Box>
    ) : null}
  </Box>
);
